var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 80,
    viewBox: "0 0 94 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4355 15.3654V15.8654H87.9355H92.4839C92.7512 15.8654 93.0089 15.9729 93.2 16.1666C93.3913 16.3605 93.5 16.6249 93.5 16.9019V78.3635C93.5 78.6405 93.3913 78.9049 93.2 79.0988C93.0089 79.2924 92.7512 79.4 92.4839 79.4H1.51613C1.24881 79.4 0.991064 79.2924 0.799973 79.0988C0.608658 78.9049 0.5 78.6405 0.5 78.3635V16.9019C0.5 16.6249 0.608658 16.3605 0.799973 16.1666C0.991064 15.9729 1.24881 15.8654 1.51613 15.8654H6.06452H6.56452V15.3654V1.53654C6.56452 1.25949 6.67317 0.995114 6.86449 0.801224C7.05558 0.607559 7.31332 0.5 7.58065 0.5H28.8064C28.8064 0.5 28.8064 0.5 28.8065 0.5C28.9939 0.500038 29.1781 0.552882 29.3386 0.653257C29.499 0.753626 29.6296 0.897796 29.7151 1.07037C29.7151 1.07048 29.7152 1.07058 29.7152 1.07068L32.3265 6.36725L32.464 6.64615H32.7749H86.4194C86.6867 6.64615 86.9444 6.75371 87.1355 6.94738C87.3268 7.14127 87.4355 7.40564 87.4355 7.68269V15.3654ZM9.09677 2.57308H8.59677V3.07308V15.3654V15.8654H9.09677H84.9032H85.4032V15.3654V9.21923V8.71923H84.9032H31.8388C31.8388 8.71923 31.8387 8.71923 31.8387 8.71923C31.6513 8.71919 31.467 8.66635 31.3066 8.56598C31.1462 8.46562 31.0156 8.32147 30.9301 8.14891C30.93 8.14879 30.93 8.14867 30.9299 8.14855L28.3187 2.85198L28.1812 2.57308H27.8702H9.09677ZM90.9677 77.3269H91.4677V76.8269V18.4385V17.9385H90.9677H3.03226H2.53226V18.4385V76.8269V77.3269H3.03226H90.9677Z",
    fill: "#0067DD",
    stroke: "#D5D5D5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.96338,
    y: 18.3623,
    width: 87.6936,
    height: 58.5409,
    fill: "#0067DD",
    fillOpacity: 0.3,
    stroke: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentV2);
export default __webpack_public_path__ + "static/media/documentV2.72e748b3.svg";
export { ForwardRef as ReactComponent };